import React from 'react';
import cn from 'classnames';
import { useLocation } from '@reach/router';
import Image from 'components/UI/Image';
import Title from 'components/UI/Title';
import Icon from 'components/UI/Icon';
import Link from 'components/UI/Link';
import { useLang } from 'utils/localisation';
import { pushCustomEvent } from 'utils/analytics';
import { modal as modalStore } from 'store';
import { getEventDuration } from 'utils/events';

import * as styles from './Card.module.scss';

export default function Card({
  image,
  title,
  subtitle,
  startDate,
  finishDate,
  location,
  url,
  theme,
  isBig = false,
  bigImage,
  global,
}) {
  const lang = useLang();
  const { pathname } = useLocation();
  const hideImagesFromAssistiveTech = pathname === '/';

  const handleClick = e => {
    if (global) {
      const { title, subtitle } = global;
      e.preventDefault();
      modalStore.open('LangNotificationModal', { href: url, target: '_blank', title, subtitle });
    }
    pushCustomEvent('ndrsn_events_block', {
      action: 'click_on_card',
      label: title,
    });
  };

  const Wrapper = url ? Link : 'div';

  return (
    <>
      <Wrapper
        className={cn(styles.wrapper, !url && styles.disabled, isBig && styles.big, styles[theme])}
        href={url}
        target="_blank"
        onClick={handleClick}
      >
        <Image
          className={styles.picture}
          classImage={styles.image}
          src={isBig ? bigImage : image}
          aria-hidden={hideImagesFromAssistiveTech}
        />
        <div className={styles.contentWrapper}>
          <div className={styles.text}>
            <Title tag="h3" size="h4">
              {title}
            </Title>
            <p className={styles.subtitle}>{subtitle}</p>
          </div>
          <div className={styles.details}>
            <div className={styles.detailItem}>
              <Icon
                className={styles.detailIcon}
                name="checked-calendar"
                aria-hidden={hideImagesFromAssistiveTech}
              />
              <span>{getEventDuration(startDate, finishDate, lang)}</span>
            </div>
            <div className={styles.detailItem}>
              <Icon
                className={styles.detailIcon}
                name="marker-filled"
                aria-hidden={hideImagesFromAssistiveTech}
              />
              <span>{location}</span>
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  );
}
